import PropTypes from 'prop-types';
import { FormattedMessage } from 'dibs-react-intl';
import { isNegotiableOrder } from '../helpers/checkoutRedirects';

// components
import DeliveryOption from '../shared/delivery/DeliveryOption';

const BuyerCustomQuote = ({ shipmentType, shipmentQuoteId, onSelect, isComputing }) => (
    <DeliveryOption
        disabled={isComputing}
        value="customQuoteNeeded"
        title={
            <FormattedMessage
                id="checkout.BuyerCustomQuote.title"
                defaultMessage="Request a custom quote"
            />
        }
        description={
            <span>
                <FormattedMessage
                    id="checkout.BuyerCustomQuote.customQuoteDescription"
                    defaultMessage="If the shipping methods above do not meet your needs (for example, you need expedited delivery), you may request a custom quote. Please indicate if you have a delivery deadline or preferred delivery method. Note that the cost for expedited shipping may be substantially higher. You will have the opportunity to review your custom quote before your order is finalized."
                />
                <br />
                <br />
                {isNegotiableOrder() ? (
                    <FormattedMessage
                        id="checkout.BuyerCustomQuote.customQuoteNegotiate"
                        defaultMessage="You will be charged only if the dealer accepts your offer and elects to provide complimentary shipping. Otherwise, if your offer is accepted, you will be asked to approve the shipping cost before your payment method is charged."
                    />
                ) : (
                    <FormattedMessage
                        id="checkout.BuyerCustomQuote.customQuoteFullPrice"
                        defaultMessage="You will be charged only if the dealer elects to provide complimentary shipping. Otherwise, you will be asked to approve the shipping quote before your payment method is charged."
                    />
                )}
            </span>
        }
        testName="FIRSTDIBS_FACILITATED"
        isSelected={shipmentType === 'FIRSTDIBS_FACILITATED' && !shipmentQuoteId}
        onSelect={() =>
            onSelect({ shipmentType: 'FIRSTDIBS_FACILITATED', isCustomQuoteSelected: true })
        }
    />
);

BuyerCustomQuote.propTypes = {
    shipmentType: PropTypes.string.isRequired,
    shipmentQuoteId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    isComputing: PropTypes.bool,
};

export default BuyerCustomQuote;
